window.initMapDistribution = function () {
  'use strict';
  var mapElement = document.getElementById('google-map-marker-distribution');
  if (!mapElement) {
    return;
  }
  var path = mapElement.dataset.path;
  var map = new google.maps.Map(mapElement, {
    mapTypeId: 'roadmap'
  });
  var iw = new google.maps.InfoWindow();
  var oms = new OverlappingMarkerSpiderfier(map, {
    markersWontMove: true,
    markersWontHide: true,
    basicFormatEvents: true
  });

  var LatLngBounds = new google.maps.LatLngBounds();

  var id = mapElement.getAttribute('data-menu-id');

  $.ajax({
    url: path,
    type: 'get'
  }).done(function (response) {
    if (response && response['map_markers'] && response['map_markers'].length) {
      for (var i = 0, feature; feature = response['map_markers'][i]; i++) {
        addMarker(feature, 5);
      }
    }
    map.fitBounds(LatLngBounds);
    var listener = google.maps.event.addListener(map, 'idle', function () {
      if (map.getZoom() > 16) map.setZoom(16);
      google.maps.event.removeListener(listener);
    });
  }).fail(function () {
    console.log('failed to get map_markers');
  });

  function addMarker(data, retry) {
    var image = {
      url: data['user']['path'],
      scaledSize: new google.maps.Size(35, 35)
    };
    var lat = Number(data['place']['lat']);
    var lng = Number(data['place']['lng']);
    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      icon: image,
      map: map
    });
    oms.addMarker(marker);
    google.maps.event.addListener(marker, 'mouseover', function (e) {
      iw.setContent(data['place']['name']);
      iw.open(map, marker);
    });
    LatLngBounds.extend(marker.position);
  }
}
